import React from "react";
import { Button } from "../../../components/tailwind";

type ChatDeleteDialogProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  confirmAction: () => void;
};

export const ChatDeleteDialog: React.FC<ChatDeleteDialogProps> = ({
  open,
  setOpen,
  confirmAction,
}) => {
  return (
    <div className={`tw-w-full ${open ? " " : "tw-hidden"}`}>
      <div className="tw-flex tw-gap-1">
        <Button
          className="tw-w-1/2"
          data-testid="section-modal-close-confirm"
          size="sm"
          compact
          variant="secondary"
          onClick={(): void => setOpen(false)}
        >
          <i className="material-icons tw-h-full">turn_left</i> Cancel
        </Button>
        <Button
          className="tw-w-1/2"
          data-testid="section-modal-confirm-action"
          content="Delete"
          size="sm"
          compact
          variant="primary"
          onClick={(): void => {
            confirmAction();
            setOpen(false);
          }}
        />
      </div>
    </div>
  );
};
